import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RefreshIcon from '@mui/icons-material/Refresh';
import {
  Box,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Checkbox,
  IconButton,
} from '@mui/material';
import styles from './PriorityItem.styles';

export type PriorityItemComponentProps = {
  checked: boolean;
  description: string;
  onChangePriorityStatus?: () => void;
  onCopyPriorityHandler?: (description: string) => void;
  hideCopyButton?: boolean;
  disablePriority?: boolean;
};

const PriorityItemComponent = function ({
  checked,
  hideCopyButton,
  disablePriority,
  description,
  onCopyPriorityHandler,
  onChangePriorityStatus,
}: PriorityItemComponentProps): JSX.Element {
  return (
    <Box sx={styles.priorityItemContainer} data-testid="box-priority">
      <ListItem sx={styles.priorityListItemContainer} disablePadding>
        <ListItemButton
          sx={styles.priorityButton}
          disabled={disablePriority}
          dense
          onClick={onChangePriorityStatus}
        >
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={checked}
              tabIndex={-1}
              disableRipple
              inputProps={{ 'aria-labelledby': 'labelId' }}
              icon={<CheckCircleOutlineIcon />}
              checkedIcon={<CheckCircleIcon />}
              data-testid="checkbox-priority"
            />
          </ListItemIcon>
          <ListItemText id="labelId" primary={description || ''} data-testid="label-priority" />
        </ListItemButton>
      </ListItem>
      {!hideCopyButton && onCopyPriorityHandler && (
        <IconButton
          sx={styles.priorityIconButton}
          edge="end"
          aria-label="copy priority"
          onClick={() => onCopyPriorityHandler(description)}
          data-testid="copy-priority-btn"
        >
          <RefreshIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default PriorityItemComponent;
